import { BuildType } from '@/services/ApiService';
import {
    ApprenticeshipDetailsArgs,
    ApprenticeshipModel,
    ApprenticeshipsResponse,
    QueryApprenticeshipParams,
    UserApprenticeshipModel,
} from '@/types/Apprenticeship';

export const apprenticeshipApiEndpoints = (build: BuildType) => ({
    apprenticeships: build.query<ApprenticeshipsResponse, QueryApprenticeshipParams>({
        query: params => ({
            url: 'apprenticeships/query',
            method: 'POST',
            body: params,
        }),
        providesTags: ['Apprenticeships'],
    }),
    apprenticeshipDetails: build.query<ApprenticeshipModel, ApprenticeshipDetailsArgs>({
        // Two segments for source-explicit URLs (programs and Lightcast postings), one for legacy
        // value-only URLs.
        query: ({ externalSourceId, externalSourceValue }) => externalSourceId
            ? `apprenticeships/${encodeURIComponent(externalSourceId)}/${encodeURIComponent(externalSourceValue)}`
            : `apprenticeships/${encodeURIComponent(externalSourceValue)}`,
    }),
    favoriteApprenticeship: build.mutation<void, ApprenticeshipModel>({
        query: apprenticeship => ({
            url: 'user-apprenticeships/favorite',
            method: 'POST',
            body: apprenticeship,
        }),
        invalidatesTags: ['Favorites', 'UserApprenticeships', 'Apprenticeships'],
    }),
    getFavoriteApprenticeships: build.query<UserApprenticeshipModel[], void>({
        query: () => 'user-apprenticeships/favorites',
        providesTags: ['UserApprenticeships'],
    }),
});
